// extracted by mini-css-extract-plugin
module.exports = {"Thumbnail":"thumbnail-module--Thumbnail--2FRon"};